// © Microsoft Corporation. All rights reserved.

import { neutralFillStealthHover, neutralForegroundHint, neutralForegroundRest, neutralLayerCard, DesignSystem } from "@microsoft/fast-components-styles-msft";
import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

export const SortBoxStyles = (config: DesignSystem) => ({
    sortBoxContainer: {
        display: "flex",
        "align-items": "center",
        "font-size": "14px",
        color: neutralForegroundHint,
        cursor: "pointer",

        "& .cwt-sort-value-container": {
            position: "relative",
            margin: "0 4px",

            "& .cwt-sort-value": {
                display: "inline-block",
                "font-weight": "bold",
                color: neutralForegroundRest,
                fill: neutralForegroundHint,

                "& .cwt-icon-vector": {
                    margin: "0 2px -2px"
                }
            }
        },

        "& .cwt-sort-list": {
            "min-width": "128px",
            margin: "0",
            padding: "6px 0",
            background: neutralLayerCard,
            border: "1px solid rgba(0, 0, 0, 0.08)",
            "border-radius": "8px",
            "box-shadow": "0px 4px 24px rgba(0, 0, 0, 0.04)",

            "& .cwt-sort-list-item": {
                padding: "6px 12px",

                "&:hover": {
                    background: neutralFillStealthHover
                },

                "& .cwt-icon": {
                    "font-size": "14px",

                    "& .cwt-icon-label": {
                        "white-space": "nowrap"
                    },

                    "& .cwt-icon-vector": {
                        "font-size": "18px",
                        margin: "-2px 4px",
                        fill: "#107C10"
                    }
                },

                "&.active .cwt-icon .cwt-icon-label": {
                    color: neutralForegroundRest
                }
            }
        }
    },

    sortBoxPopover: {
        [applyLocalizedProperty("left", "right", config.direction)]: "-6px",
        top: "10px"
    }
});